export default "__VITE_ASSET__fa4aa47f__"